/* Mail de collaboration precrit et modifiable (sections/rp-mail-partenaire.liquid).
   - un modele par profil ; [Ton prénom] et [Ton lien] se remplissent depuis deux champs ;
   - une fois le message retouche a la main, le profil garde ce brouillon : changer
     de profil puis revenir ne le perd pas ;
   - envoi : messagerie du visiteur (mailto), Gmail, ou copie ; rien ne part du site. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.rpInit) { return; }
    root.dataset.rpInit = '1';

    var modeles = [];
    try { modeles = JSON.parse(root.querySelector('[data-rp-modeles]').textContent); } catch (e) { return; }
    if (!modeles.length) { return; }

    var email = root.dataset.email || '';
    var tokenNom = root.dataset.tokenNom || '[Ton prénom]';
    var tokenLien = root.dataset.tokenLien || '[Ton lien]';
    var $ = function (sel) { return root.querySelector(sel); };
    var champNom = $('[data-rp-nom]'), champLien = $('[data-rp-lien]');
    var champObjet = $('[data-rp-objet]'), champMessage = $('[data-rp-message]');
    var etat = $('[data-rp-etat]');
    var brouillons = {};             // id de profil -> { objet, message } une fois retouche a la main
    var courant = modeles[0];

    function remplir(texte) {
      var nom = champNom.value.trim(), lien = champLien.value.trim();
      if (nom) { texte = texte.split(tokenNom).join(nom); }
      if (lien) { texte = texte.split(tokenLien).join(lien); }
      return texte;
    }

    function afficher() {
      var b = brouillons[courant.id];
      champObjet.value = b && b.objet !== null ? b.objet : remplir(courant.objet);
      champMessage.value = b && b.message !== null ? b.message : remplir(courant.message);
    }

    function note(texte, erreur) {
      etat.textContent = texte || '';
      etat.style.color = erreur ? '#dc0428' : '';
    }

    function brouillon() {
      return brouillons[courant.id] || (brouillons[courant.id] = { objet: null, message: null });
    }

    champObjet.addEventListener('input', function () { brouillon().objet = champObjet.value; });
    champMessage.addEventListener('input', function () { brouillon().message = champMessage.value; });

    function surChamp() {
      // Les crochets encore presents dans un texte retouche sont remplis aussi.
      Object.keys(brouillons).forEach(function (id) {
        var b = brouillons[id];
        if (b.objet !== null) { b.objet = remplir(b.objet); }
        if (b.message !== null) { b.message = remplir(b.message); }
      });
      afficher();
    }
    champNom.addEventListener('input', surChamp);
    champLien.addEventListener('input', surChamp);

    root.querySelectorAll('[data-rp-profils] input[type="radio"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var m = modeles.filter(function (x) { return x.id === r.value; })[0];
        if (m) { courant = m; afficher(); note(''); }
      });
    });

    function corps() { return champMessage.value.replace(/\r?\n/g, '\r\n'); }

    function majLiens() {
      var objet = encodeURIComponent(champObjet.value), body = encodeURIComponent(corps());
      $('[data-rp-mailto]').href = 'mailto:' + encodeURIComponent(email).replace(/%40/g, '@') + '?subject=' + objet + '&body=' + body;
      $('[data-rp-gmail]').href = 'https://mail.google.com/mail/?view=cm&fs=1&to=' + encodeURIComponent(email) + '&su=' + objet + '&body=' + body;
    }
    // Les liens se refont au moment du clic : le texte est toujours a jour.
    ['[data-rp-mailto]', '[data-rp-gmail]'].forEach(function (sel) {
      var a = $(sel);
      ['pointerdown', 'focus', 'click'].forEach(function (ev) { a.addEventListener(ev, majLiens); });
    });
    majLiens();

    function copier() {
      var texte = 'Objet : ' + champObjet.value + '\n\n' + champMessage.value;
      var ok = function () { note('Message copié. Colle-le dans ta messagerie, à l’adresse ' + email + '.'); };
      var secours = function () {
        var t = document.createElement('textarea');
        t.value = texte; t.setAttribute('readonly', ''); t.style.position = 'fixed'; t.style.opacity = '0';
        document.body.appendChild(t); t.select();
        try { document.execCommand('copy') ? ok() : note('Copie impossible : sélectionne le message à la main.', true); }
        catch (e) { note('Copie impossible : sélectionne le message à la main.', true); }
        document.body.removeChild(t);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(texte).then(ok, secours); }
      else { secours(); }
    }
    $('[data-rp-copier]').addEventListener('click', copier);

    afficher();
  }

  function tout() { document.querySelectorAll('[data-rp-mail]').forEach(init); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', tout); } else { tout(); }
  document.addEventListener('shopify:section:load', tout);
})();
